import { create } from "zustand";
const useTicTacToeStore = create((set) => ({
    isXNext: true,
    moveOrder: [],
    squares: Array(9).fill(null),
    gameMode: "threeMoves",
    setIsXNext: (isXNext) => set({ isXNext }),
    setMoveOrder: (moveOrder) => set({ moveOrder }),
    setSquares: (squares) => set({ squares }),
    toggleGameMode: () => set((state) => ({
        gameMode: state.gameMode === "threeMoves" ? "resetMode" : "threeMoves",
    })),
    handleNextStarter: () => set((state) => ({ isXNext: !state.isXNext })),
}));
export default useTicTacToeStore;
